module.exports = __webpack_public_path__ + "img/partner.7fb742cb.png";